<template>
  <div class="h5-container">
    <!-- 顶部导航 -->
    <van-nav-bar
        class="top-bar"
        title="销售管理"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    >
      <template #right>
        <span class="nav-add" @click="onAdd">新增</span>
      </template>
    </van-nav-bar>

    <div class="container-item">
      <!-- 列表 -->
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="loadData"
      >
        <div v-for="item in list" :key="item.userId || item.id" class="custom-card">
          <div class="card-header">
            <div class="header-left">
              <div class="avatar">{{ getAvatarText(item) }}</div>
              <span class="item-title">{{ item.nickName || item.userName || '未命名' }}</span>
            </div>
            <div class="delete-btn" @click="handleDelete(item)">
              <van-icon name="delete-o" />
              <span>删除</span>
            </div>
          </div>
          <div class="card-body">
            <div class="info-row">
              <van-icon name="phone-o" class="row-icon" />
              <span class="value">{{ formatPhone(item) }}</span>
            </div>
            <div class="info-row" v-if="item.merchantName">
              <van-icon name="shop-o" class="row-icon" />
              <span class="value">{{ item.merchantName }}</span>
            </div>
          </div>
        </div>
        <div v-if="list.length === 0 && !loading" class="empty-tip">
          <van-icon name="contact" size="48" />
          <p>暂无销售人员</p>
        </div>
      </van-list>
    </div>

    <!-- 删除确认弹窗 -->
    <van-dialog
        v-model="showDeleteDialog"
        title="确认删除"
        message="确定要删除该销售人员吗？"
        :show-cancel-button="true"
        cancel-button-text="取消"
        confirm-button-text="确定"
        @confirm="confirmDelete"
    />
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import { selectSaleUserPage, deleteSalesUser } from '@/api/sales';
import { Toast } from 'vant';

export default {
  name: 'SaleManage',
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      showDeleteDialog: false,
      deleteItem: null
    };
  },
  methods: {
    onClickLeft() {
      this.$router.push('/app_home');
    },
    onAdd() {
      this.$router.push('/sale_manage_add');
    },
    // 重置到第一页并重新加载
    reload() {
      this.pageNum = 1;
      this.list = [];
      this.finished = false;
      this.loading = true;
      this.loadData();
    },
    async loadData() {
      if (this.finished) {
        this.loading = false;
        return;
      }
      try {
        const res = await selectSaleUserPage({
          pageNum: this.pageNum,
          pageSize: this.pageSize
        });
        if (res.code === 200 && res.data) {
          const rows = res.data.rows || [];
          this.list = this.pageNum === 1 ? rows : this.list.concat(rows);
          const total = res.data.total || 0;
          // 已加载数达到总数 或 本页不足一页，视为没有更多
          if (rows.length < this.pageSize || this.list.length >= total) {
            this.finished = true;
          } else {
            this.pageNum++;
          }
        } else {
          this.finished = true;
          Toast(res.returnMsg || '加载失败');
        }
      } catch (error) {
        console.error('加载失败：', error);
        this.finished = true;
        Toast('加载失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    // 头像首字（取昵称/账号第一个字符）
    getAvatarText(item) {
      const name = item.nickName || item.userName || '';
      return name ? name.charAt(0).toUpperCase() : '销';
    },
    // 手机号展示（兼容 phoneNumber / phonenumber 两种字段）
    formatPhone(item) {
      const phone = item.phoneNumber || item.phonenumber;
      if (!phone) return '-';
      return phone.length === 11 ? phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') : phone;
    },
    handleDelete(item) {
      this.deleteItem = item;
      this.showDeleteDialog = true;
    },
    async confirmDelete() {
      if (!this.deleteItem) return;
      const userId = this.deleteItem.userId || this.deleteItem.id;
      try {
        const res = await deleteSalesUser(userId);
        if (res.code === 200) {
          Toast(res.returnMsg || '删除成功');
          this.reload();
        } else {
          Toast(res.returnMsg || '删除失败');
        }
      } catch (error) {
        Toast('删除失败，请稍后重试');
      } finally {
        this.deleteItem = null;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.h5-container {
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #000;
  padding-bottom: 40px;

  @media (min-width: 768px) {
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
    padding-bottom: 60px;
  }
}

::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;

  @media (min-width: 768px) {
    font-size: 24px;
  }
}

::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;

  @media (min-width: 768px) {
    font-size: 18px;
  }
}

::v-deep .van-nav-bar__title {
  @media (min-width: 768px) {
    font-size: 22px;
    font-weight: bold;
  }
}

.top-bar {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);

  @media (min-width: 768px) {
    height: 70px;
    line-height: 70px;
  }
}

.nav-add {
  color: #0f0f0f;
  font-size: 14px;
  font-weight: bold;

  @media (min-width: 768px) {
    font-size: 18px;
  }
}

.container-item {
  padding: 0 16px;
  margin-bottom: 60px;

  @media (min-width: 768px) {
    padding: 0 20px;
    margin-bottom: 80px;
  }
}

.header-left {
  display: flex;
  align-items: center;
  min-width: 0;
}

.avatar {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  margin-right: 10px;
  border-radius: 50%;
  background: linear-gradient(135deg, #F5D76E 0%, #D4AF37 55%, #9E7B0A 100%);
  color: #1a1a1a;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(212, 175, 55, 0.35);

  @media (min-width: 768px) {
    width: 44px;
    height: 44px;
    margin-right: 14px;
    font-size: 20px;
  }
}

.item-title {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (min-width: 768px) {
    font-size: 18px;
  }
}

.empty-tip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #666;

  .van-icon {
    color: #D4AF37;
    opacity: 0.7;
  }

  p {
    margin-top: 10px;
    font-size: 14px;
  }

  @media (min-width: 768px) {
    padding: 80px 0;

    p {
      font-size: 16px;
    }
  }
}

.custom-card {
  position: relative;
  margin: 14px 0;
  border-radius: 12px;
  background: #fff;
  border: 1px solid rgba(212, 175, 55, 0.18);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);
  overflow: hidden;
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: linear-gradient(180deg, #F5D76E 0%, #D4AF37 50%, #9E7B0A 100%);
  }

  &:active {
    transform: scale(0.99);
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
  }

  @media (min-width: 768px) {
    margin: 18px 0;
    border-radius: 14px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.22);
  }
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 15px 12px;
  border-bottom: 1px solid #f2f2f2;

  @media (min-width: 768px) {
    padding: 18px 22px 14px;
  }
}

.card-body {
  padding: 12px 15px 14px;

  @media (min-width: 768px) {
    padding: 14px 22px 18px;
  }
}

.info-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 13px;
  width: 100%;
  color: #555;

  &:last-child {
    margin-bottom: 0;
  }

  .row-icon {
    flex-shrink: 0;
    margin-right: 8px;
    font-size: 15px;
    color: #D4AF37;
  }

  .value {
    color: #333;
    word-break: break-all;
  }

  @media (min-width: 768px) {
    margin-bottom: 14px;
    font-size: 15px;

    .row-icon {
      margin-right: 10px;
      font-size: 18px;
    }

    .value {
      font-size: 15px;
      line-height: 1.6;
    }
  }
}

/* 删除按钮：描边胶囊样式 + 图标 */
.delete-btn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  height: 30px;
  padding: 0 12px;
  border-radius: 15px;
  border: 1px solid rgba(230, 67, 64, 0.45);
  background: rgba(230, 67, 64, 0.06);
  color: #E64340;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;

  .van-icon {
    margin-right: 4px;
    font-size: 14px;
  }

  &:active {
    background: #E64340;
    border-color: #E64340;
    color: #fff;
  }

  @media (min-width: 768px) {
    height: 34px;
    padding: 0 16px;
    border-radius: 17px;
    font-size: 14px;

    .van-icon {
      font-size: 16px;
    }
  }
}
</style>
